import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { State } from '../../../../core/store';
import { loadProfile } from '../../../../core/store/profile/profile.actions';
import {
  getEquipmentAssignPdf,
  signEquipmentAssign,
  signEquipmentAssignSuccess
} from '../../../../core/store/equipment/equipment.actions';
import { AlertService } from '../../../../shared/services/alert.service';
import { downloadFile } from 'src/app/helpers/utils';
import { UserModel } from 'src/app/models/userModel';
import { SignDocComponentBase } from '../../../abstract/signDocBase.component';

@Component({
    selector: 'app-sign-assign-equipment',
    templateUrl: './sign-assign-equipment.component.html',
    styleUrls: ['./sign-assign-equipment.component.scss'],
    standalone: false
})
export class SignAssignEquipmentComponent extends SignDocComponentBase implements OnInit, AfterViewInit {
  assignedEquipmentID: number;
  loadingSign = false;
  loadingDoc = true;
  user: UserModel;

  constructor(
    private store: Store<State>,
    private actions$: Actions,
    private alert: AlertService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(store);
  }

  ngOnInit() {
    this.store.dispatch(loadProfile());

    this.route.params.subscribe(params => {
      if (params.assignedEquipmentID) {
        this.assignedEquipmentID = parseInt(params.assignedEquipmentID, 10);
        this.store.dispatch(getEquipmentAssignPdf({
          assignedEquipmentID: this.assignedEquipmentID,
          returned: false,
          download: false
        }));
      }
    });

    this.subs.push(
      this.store.select(s => s.profileState.profile).subscribe(profile => {
        if (profile) {
          this.user = profile.user;
        }
      }),
      this.store.select(s => s.equipmentState.docArrayBuffer).subscribe(docArrayBuffer => {
        if (docArrayBuffer) {
          this.url = URL.createObjectURL(new Blob([docArrayBuffer], { type: 'application/pdf' }));
        }
      }),
      this.store.select(s => s.equipmentState.loadingDoc).subscribe(loadingDoc => {
        this.loadingDoc = loadingDoc;
      }),
      this.store.select(s => s.equipmentState.loadingSign).subscribe(loadingSign => {
        this.loadingSign = loadingSign;
      }),
      this.actions$.pipe(
        ofType(signEquipmentAssignSuccess),
        tap(action => {
          this.alert.confirm(
            'Documentation signed successfully',
            'Documentation signed successfully. Do you want to download the signed file now?'
          ).subscribe(
            answer => {
              if (answer) {
                downloadFile(action.docSigned, 'Asset Assign Signed.pdf');
              }

              this.router.navigate(['/equipment/my']);
            },
            () => {
              this.router.navigate(['/equipment/my']);
            }
          );
        })
      ).subscribe()
    );
  }

  get loggedUserName() {
    return !this.user ? '' : `${this.user.firstName} ${this.user.lastName}`;
  }

  get loggedUserEmail() {
    return !this.user ? '' : this.user.email;
  }

  sign() {
    if (!this.finishSignDisabled) {
      this.store.dispatch(signEquipmentAssign({
        assignedEquipmentID: this.assignedEquipmentID,
        signedFields: this.signedFields
      }));
    }
  }
}
